import { useRef, useState } from "react";

const ZOOM_LEVEL = 2;
const CLICK_TOLERANCE_PX = 4;

const clampPercent = (value) => Math.min(100, Math.max(0, value));

const ZoomableDocument = ({ children }) => {
  const [isZoomed, setIsZoomed] = useState(false);
  const [origin, setOrigin] = useState({ x: 50, y: 50 });
  const panRef = useRef(null);

  const onPointerDown = (event) => {
    panRef.current = { clientX: event.clientX, clientY: event.clientY, origin, hasMoved: false };
    if (isZoomed) event.currentTarget.setPointerCapture(event.pointerId);
  };

  const onPointerMove = (event) => {
    const pan = panRef.current;
    if (!isZoomed || !pan || event.buttons !== 1) return;
    const deltaX = event.clientX - pan.clientX;
    const deltaY = event.clientY - pan.clientY;
    if (!pan.hasMoved && Math.hypot(deltaX, deltaY) < CLICK_TOLERANCE_PX) return;
    pan.hasMoved = true;
    const { offsetWidth, offsetHeight } = event.currentTarget;
    setOrigin({
      x: clampPercent(pan.origin.x - (deltaX / offsetWidth / (ZOOM_LEVEL - 1)) * 100),
      y: clampPercent(pan.origin.y - (deltaY / offsetHeight / (ZOOM_LEVEL - 1)) * 100),
    });
  };

  const onClick = (event) => {
    if (panRef.current?.hasMoved) return;
    if (isZoomed) return setIsZoomed(false);
    const rect = event.currentTarget.getBoundingClientRect();
    setOrigin({ x: ((event.clientX - rect.left) / rect.width) * 100, y: ((event.clientY - rect.top) / rect.height) * 100 });
    setIsZoomed(true);
  };

  return (
    <div
      className={`select-none ${isZoomed ? "cursor-grab touch-none active:cursor-grabbing" : "cursor-zoom-in"}`}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onClick={onClick}
      onDragStart={(event) => event.preventDefault()}
      style={{
        transform: `scale(${isZoomed ? ZOOM_LEVEL : 1})`,
        transformOrigin: `${origin.x}% ${origin.y}%`,
        transition: "transform 0.2s ease-out",
      }}
    >
      {children}
    </div>
  );
};

export default ZoomableDocument;
